import { forwardRef, useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../Context/AppContext';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerComponent.scss';
import { getTimeFormatAccordingToPreference } from '../../../Utils/DateUtils';
interface IDatePickerComponent {
  type: string;
  label?: String;
  isToDate?: boolean;
  customClass?: any;
  value: any;
  handleChange: (type: string, data: any) => void;
  errorMessage?: any;
  datePickerdisabled?: boolean;
  showTimeSelector?: boolean;
  minDate?: any;
}

const DatePickerComponent = (props: IDatePickerComponent) => {
  const { isMobile } = useContext(AppContext);
  const {
    type,
    label,
    isToDate,
    customClass,
    value,
    handleChange,
    errorMessage,
    datePickerdisabled,
    showTimeSelector,
    minDate,
  } = props;

  const [selectedDate, setSelectedDate] = useState(value);

  const setDateAndTime = (event: any) => {
    const updatedDate = dayjs(event).toDate();
    setSelectedDate(updatedDate);
    handleChange(type, updatedDate);
  };

  useEffect(() => {
    setSelectedDate(value ? dayjs(value).toDate() : null);
  }, [value]);

  const CustomInput = forwardRef((props: any, ref: any) => {
    return (
      <div
        onChange={props?.onChange}
        id={props?.id}
        onClick={props?.onClick}
        className={`Custom_Input ${isMobile && isToDate ? 'Label_Align' : ''}`}
        ref={ref}
      >
        {isMobile && !showTimeSelector ? (
          <>
            <p>{dayjs(props.value).format('ddd')}</p>
            <p>{dayjs(props.value).format('MMM DD, YYYY')}</p>
          </>
        ) : (
          <div className="DatePickerComponent_Custom_Web" data-testid="DatePickerComponent">
            <span>
              {dayjs(props.value).format(
                showTimeSelector
                  ? `ddd, MMM D, ${getTimeFormatAccordingToPreference(true)}`
                  : 'ddd, MMM DD, YYYY',
              )}
            </span>
            <img src="/oo/assets/icon/Calendar.svg" alt="Calendar" />
          </div>
        )}
      </div>
    );
  });

  return (
    <div className={`DatePicker_Container ${type} ${showTimeSelector ? 'TimeSelect' : ''}`}>
      <p className={`DatePicker_Label ${isMobile && isToDate ? 'Label_Align' : ''}`}>{label}</p>
      <div
        className={`DatePicker_Wrapper ${!!errorMessage ? 'error' : ''} ${
          datePickerdisabled ? 'disabled' : ''
        }`}
      >
        <DatePicker
          selected={selectedDate}
          customInput={<CustomInput value={selectedDate} />}
          onChange={(event: any) => {
            setDateAndTime(event);
          }}
          minDate={minDate ? minDate : new Date()}
          dateFormat={
            showTimeSelector
              ? `EEEE MMM d, yyyy, ${getTimeFormatAccordingToPreference(true, false, true)}`
              : 'EEEE MMM d, yyyy'
          }
          timeFormat={getTimeFormatAccordingToPreference(true, false, true)}
          calendarClassName={customClass}
          disabled={datePickerdisabled}
          showTimeSelect={showTimeSelector}
          timeIntervals={5}
          popperPlacement="top"
        />
        {!!errorMessage && <span className="errorMessage">{errorMessage}</span>}
      </div>
      {/* TO DO: Add icon when !isMobile */}
    </div>
  );
};

export default DatePickerComponent;
